import React, { useState } from "react";
import Images from "../../../media/images";
import { useForm } from "react-hook-form";
import api from "../../../api/api";
import { toast } from "react-toastify";

const UpdateNotice = ({ noticeItem, setChanges,changes }) => {
  const { register, handleSubmit, setValue } = useForm();
  const [img, SetImg] = useState("");


  const onSubmit = (data) => {

    const user = JSON.parse(localStorage.getItem("user"));
    // console.log('user',user)

    const formData = new FormData();

    formData.append("author", user?.user_id);
    formData.append("image", data.image[0]);
    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("author_id", user.user_id);

    const {image, ...newDatas} = data 


    api
      .patch(`/notices/${noticeItem.id}/`, 
         data.image.length === 0 ? newDatas : formData
      )
      .then((response) => {
        setChanges(!changes)
        toast.success("Notice updated successfully");

      })
      .catch((error) => {
        toast.error("Something went wrong in updating");
      });
  };

  return (
    <div
      className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
      id="NoticeListDemo"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
        <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
          <div className="flex justify-end">
            <svg
              data-bs-dismiss="modal"
              aria-label="Close"
              className="text-primary-blue h-8 w-8"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
              />
            </svg>
          </div>
          <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
            <div className="">
              <div className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
                Update Notice
              </div>
              <div className="">
                <img
                  src={Images.title_border}
                  alt=""
                  className="mx-auto mt-4"
                />
              </div>

              <div className="my-2">
                <img src={noticeItem.image} className="w-56 object-fill m-auto" />
              </div>

              

              {/* <div className="flex justify-center gap-3 mt-1">
                <img src={noticeItem.image} className="w-40" />

                <div className="flex items-center p-2 ">
                  <label htmlFor="" className="text-primary-red">
                    Notice Photo:
                  </label>
                  <input
                    type="file"
                    name=""
                    className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
                    id=""
                    onChange={(e)=> SetImg(e.target.files[0])} 
                  />
                </div>
              </div> */}

              <div className="mt-5 px-3 md:!px-10">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="grid md:grid-cols-2">
                    <div className="border-primary-blue flex items-center gap-2 border-2 p-2">
                      <label htmlFor="" className="text-primary-red">
                        Staff Name
                      </label>
                      <input
                        type="text"
                        name=""
                        className="flex-grow py-2 px-2 outline-none"
                        id=""
                        placeholder="Staff name"
                        {...register(
                          "staff_name",
                          setValue("staff_name", noticeItem.staff_name)
                        )}
                      />
                    </div>
                    <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
                      <label htmlFor="" className="text-primary-red">
                        Date
                      </label>
                      <input
                        type="text"
                        name=""
                        className="flex-grow py-2 px-2 outline-none"
                        id=""
                        placeholder="date"
                        {...register(
                          "created_at",
                          setValue(
                            "created_at",
                            noticeItem?.created_at?.split("T")[0]
                          )
                        )}
                      />
                    </div>
                    <div className="border-primary-blue flex flex-wrap items-center gap-2 border-2 border-t-0 p-2">
                      <label htmlFor="" className="text-primary-red">
                        Notice Heading:
                      </label>
                      <input
                        type="text"
                        name=""
                        className="flex-grow  py-2 px-2 outline-none"
                        placeholder="Notice Heading"
                        {...register(
                          "title",
                          { required: false },
                          setValue("title", noticeItem?.title)
                        )}
                      />
                    </div>
                    <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
                      <label htmlFor="" className="text-primary-red">
                        Notice Photo:
                      </label>
                      <input
                        type="file"
                        name=""
                        className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
                        id=""
                        {...register("image", { required: false })}
                      />
                    </div>
                  </div>
                  <div className="border-primary-blue border-2 border-t-0 p-2">
                    <p className="text-primary-red font-bold">Notice Details</p>
                    <textarea
                      name=""
                      className="w-full border border-gray-700"
                      id=""
                      rows="{10}"
                      {...register(
                        "description",
                        setValue("description", noticeItem?.description)
                      )}
                    />
                  </div>
                  <div className="flex items-center justify-center">
                    <button
                      className="bg-primary-blue mt-3 text-center  gap-2 rounded-md px-5 py-3 font-bold text-white"
                      type="submit"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotice;
